import $ from 'jquery'
import LiveViewer from "./widgets/live-viewer";
import Header from "./widgets/header";
import VueHeader from "./widgets/vue-header";
import LoginButton from "./modules/login-button";
import Login from "./widgets/login";
import NewsletterSubscription from "./widgets/newsletter-subscription";
import BreakingNews from "./widgets/breaking-news";
import CheckUserLogged from "./widgets/check-user-logged";
import domEvents from "./modules/dom-events";
import Ranking from "./widgets/ranking";

LiveViewer.init();
VueHeader.init();
new Header();
domEvents.init();

$('[data-id="widget-breaking-news"]').each(function(){
    new BreakingNews(this);
});

$('[data-login-show]').each(function(){
    new LoginButton(this);
});

$('[data-login-form]').each(function () {
    new Login(this, false);
});

$('[data-id="c-ranking"]').each(function () {
    new Ranking(this);
});

$('[data-id="newsletter-subscription"]').each(function () {
    new NewsletterSubscription(this);
});

$('[data-id="widget-check-user-logged"]').each(function (){
    new CheckUserLogged(this);
});